import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import ThemeContext from '../../../providers/ThemeProvider';
import XLDealCard from '../XlDealCard';

const NewDeal = () => {
  const [deals, filtersURL] = useSelector((state) => [
    state.deals.deals,
    state.filters.url,
  ]);
  const getFirstDeal = deals[0];
  const theme = useContext(ThemeContext);

  return (
    <div className="new-deal">
      <XLDealCard deal={getFirstDeal} filtersURL={filtersURL} />
      <style jsx>{`
        .new-deal {
          margin-top: 20px;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .new-deal {
            margin-bottom: 20px;
          }
        }
        @media (min-width: ${theme.breakpoints.xlUp}) {
          .new-deal {
            margin-bottom: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default NewDeal;
